import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './navigation.module.scss';
import Menu from './helpers/Menu';
import SocialIcons from '../../socialIcons/socialIcons';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import MobileAppCard from '../../mobileApp/mobileApp';

export default function Navigation({ navigation = [] }) {
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);

  return (
    <div className={styles.navigation}>
      {navigation?.length > 0 &&
        navigation?.map((column, index) => {
          const key = `column-${index}`;
          return (
            <div key={key} className={styles.column}>
              <Menu column={column} />
              {!isMobile && (
                <>
                  {column[column.length - 1]?.description && (
                    <MobileAppCard {...column[column.length - 1]} />
                  )}
                  {navigation.length === index + 1 && <SocialIcons title="" />}
                </>
              )}
            </div>
          );
        })}
      {isMobile && (
        <>
          {navigation[navigation.length - 1][
            navigation[navigation.length - 1].length - 1
          ]?.description && (
            <MobileAppCard
              {...navigation[navigation.length - 1][
                navigation[navigation.length - 1].length - 1
              ]}
            />
          )}
          <SocialIcons title="" />
        </>
      )}
    </div>
  );
}

Navigation.propTypes = {
  navigation: PropTypes.array,
};
